// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconHardwareDevicesSmartphoneAddOnQuestion_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="26.75" cy="26.75" r="5.25" fill="#828D9E"/>
  <path d="M29.2 25.2041C29.2 23.9868 28.0688 23 26.6738 23 25.4553 23 24.4377 23.7531 24.2 24.7552L25.6412 25.2041C25.6412 24.7073 26.1048 24.3033 26.6736 24.3033 27.2429 24.3033 27.706 24.7073 27.706 25.2041 27.706 25.5396 27.4942 25.8329 27.1815 25.9878 26.6874 26.2391 26.3009 26.6335 26.0933 27.1045 26.0232 27.265 25.9739 27.4339 25.948 27.6097H25.9494V28H27.4759V27.6097H27.4731C27.5552 27.3935 27.7286 27.2136 27.9538 27.1045H27.9523C28.699 26.7219 29.2 26.0142 29.2 25.2041ZM27.5333 28.8333H25.8666V30.5H27.5333V28.8333Z" class="svg-fg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24 4H8V28H19.6074C19.5368 27.5939 19.5 27.1763 19.5 26.75C19.5 24.9331 20.1684 23.2723 21.2726 22H10V6H22V21.2726C22.5907 20.76 23.2651 20.3412 24 20.0397V4ZM16.9987 25C16.9987 25.5523 16.551 26 15.9987 26C15.4464 26 14.9987 25.5523 14.9987 25C14.9987 24.4477 15.4464 24 15.9987 24C16.551 24 16.9987 24.4477 16.9987 25Z" class="svg-bg"/>
</svg>
`;
/**
 * IconHardwareDevicesSmartphoneAddOnQuestion is a generated icon component.
 */
let IconHardwareDevicesSmartphoneAddOnQuestion = IconHardwareDevicesSmartphoneAddOnQuestion_1 = class IconHardwareDevicesSmartphoneAddOnQuestion extends IconBaseElement {
    render() {
        return html `${IconHardwareDevicesSmartphoneAddOnQuestion_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconHardwareDevicesSmartphoneAddOnQuestion.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconHardwareDevicesSmartphoneAddOnQuestion = IconHardwareDevicesSmartphoneAddOnQuestion_1 = __decorate([
    customElement('zui-icon-hardware-devices-smartphone-add-on-question')
], IconHardwareDevicesSmartphoneAddOnQuestion);
export { IconHardwareDevicesSmartphoneAddOnQuestion };
